<template>
  <div>
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getVersion === 'v1'">
        <b-col cols="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("paymentInformation") }}
              </h1>
              <p class="font-size-large text-center dodger-blue-text">
                {{ $translate("enterPaymentInformation") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5">
          <shetab-stepper></shetab-stepper>
          <b-row class="mx-1">
            <b-col
              cols="12"
              class="pt-2 d-flex justify-content-center align-items-center"
            >
              <span class="text-center dodger-blue-text font-size-medium-small">
                {{ $translate("shopName") }}: {{ $translate("caspianPay") }}
              </span>
            </b-col>
            <b-col
              cols="12"
              class="text-center light-grey-text pt-2 font-size-small pb-3 border-bottom-light-gray-2px-dashed"
            >
              {{ $translate("timeRemaining") }}:
              <strong class="red-text">
                <Timer
                  ref="Transaction"
                  :spanClass="'red-text'"
                  :duration="300000"
                  :timerKey="'Transaction'"
                  @expired="expiredTransactionTimerAction"
                />
              </strong>
            </b-col>
          </b-row>
          <b-row class="font-size-small pt-2">
            <b-col cols="6"
              ><span class="light-grey-text"
                >{{ $translate("amountToPay") }}:</span
              ></b-col
            >
            <b-col cols="6" class="text-start"
              ><span class="green-text font-weight-bold"
                >{{ getShetabSelectedPayingAmount | commaSep | persianDigit }}
                {{ $translate("toman") }}</span
              >
            </b-col>
          </b-row>
          <b-container
            class="background-secondary border-radius-10px border-light-gray-1px mt-1 p-2 mb-3"
          >
            <b-row>
              <b-col
                cols="12"
                class="pb-1 midnight-blue-text font-weight-bold font-size-small"
              >
                {{ $translate("cardNumber") }}:
              </b-col>
              <b-col cols="12" class="pb-1 midnight-blue-text font-size-xs"
                >{{ $translate("enter16DigitCardNumber") }}
              </b-col>
            </b-row>
            <b-row class="direction-ltr m-0 pb-3">
              <div class="input-group p-0">
                <div class="input-group-prepend">
                  <span class="input-group-text fill-height">
                    <img
                      :src="bankImageSource"
                      height="25"
                      width="25"
                      v-if="checkIfInputNotEmpty"
                    />
                  </span>
                </div>
                <input
                  v-for="(key, i) in creditCardInfo"
                  :value="creditCardInfo[i].value"
                  :key="i"
                  readonly
                  class="col-2 form-control mx-1"
                />
              </div>
            </b-row>
            <!--        <b-row style="padding-bottom:30px;" v-if="getNationalCodeNeeded">
                      <b-col cols="12" style="color: midnightblue; font-size: 0.8rem; padding-bottom: 3px;">
                        <span style="font-weight: bold">کد ملی</span>
                      </b-col>
                      <b-col cols="12" style="padding-bottom: 5px; color: midnightblue; font-size: 0.7rem">کد ملی  خود را وارد کنید</b-col>
                      <b-col cols="12">
                        <b-form-input class="form-control" type="password"  v-mask="'##########'" mask="false" v-model="nationalCode"></b-form-input>
                      </b-col>
                    </b-row>-->
            <b-row class="pb-4">
              <b-col cols="12" class="midnight-blue-text font-size-small pb-1">
                <span class="font-weight-bold">{{
                  $translate("cvv2Title")
                }}</span>
                <span>(cvv2)</span>
              </b-col>
              <b-col cols="12" class="pb-1 midnight-blue-text font-size-xs"
                >{{ $translate("enterCvv2CodeInsertedIntoYourCard") }}
              </b-col>
              <b-col cols="12">
                <b-form-input
                  class="form-control"
                  type="text"
                  pattern="\d*"
                  inputmode="numeric"
                  v-mask="'####'"
                  mask="false"
                  v-model="creditCardCVV2"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-col
              cols="12"
              class="midnight-blue-text font-size-small pb-1 font-weight-bold"
            >
              {{ $translate("cardExpireTime") }}:
            </b-col>
            <b-col cols="12" class="pb-1 midnight-blue-text font-size-xs"
              >{{ $translate("enterTheMonthAndYearOfCardExpiration") }}
            </b-col>
            <b-row class="midnight-blue-text m-0 pb-3">
              <b-col cols="6" class="pr-0 pl-0point5">
                <b-form-input
                  id="expireDateMonthInput"
                  :placeholder="$translate('month')"
                  pattern="\d*"
                  inputmode="numeric"
                  v-mask="'##'"
                  mask="false"
                  v-model="creditCardExpireDateMonth"
                  :state="creditCardMonthExpireValidation"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="pl-0 pr-0point5">
                <b-form-input
                  id="expireDateYearInput"
                  class="col-6"
                  :placeholder="$translate('year')"
                  pattern="\d*"
                  inputmode="numeric"
                  v-mask="'##'"
                  mask="false"
                  v-model="creditCardExpireDateYear"
                  :state="creditCardMonthExpireValidation"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="pb-3">
              <b-col
                cols="12"
                class="midnight-blue-text font-size-small pb-1 font-weight-bold"
              >
                {{ $translate("cardSecondInternetPassword") }}:
              </b-col>
              <b-col cols="12" class="pb-1 midnight-blue-text font-size-small"
                >{{ $translate("enterTheSentPooyaPassword") }}
              </b-col>
              <b-row class="pl-0">
                <b-col cols="8" class="pl-0">
                  <b-form-input
                    id="creditCardPasswordInput"
                    class="form-control"
                    type="password"
                    pattern="\d*"
                    inputmode="numeric"
                    v-mask="'########'"
                    mask="false"
                    v-model="creditCardPassword"
                  ></b-form-input>
                </b-col>
                <b-col cols="4" class="pl-0">
                  <button class="password-request-button">
                    <span
                      class="font-weight-bold"
                      v-if="!passwordRequestSend && !passwordRequestPending"
                      @click="getCreditCardPass()"
                      >{{ $translate("receivePassword") }}</span
                    >
                    <div
                      v-if="passwordRequestPending && !passwordRequestSend"
                      class="spinner-border text-dark"
                      style="width: 0.9rem; height: 0.9rem"
                    ></div>
                    <span v-if="passwordRequestSend" class="text-white">
                      <Timer
                        ref="PasswordRequest"
                        :spanClass="'text-white'"
                        :duration="120000"
                        :timerKey="'PasswordRequest'"
                        @expired="expiredPasswordRequestAction"
                      />
                    </span>
                  </button>
                </b-col>
              </b-row>
            </b-row>
            <b-col cols="12" class="pb-3">
              <label class="switch">
                <input type="checkbox" v-model="saveCardInfo" />
                <span class="slider round"> </span>
              </label>
              <span
                class="px-1 font-size-small font-weight-bold dodger-blue-text"
                >{{ $translate("saveCArdNumberAndExpireDate") }}</span
              >
            </b-col>
            <b-row class="pb-4">
              <b-col cols="4">
                <button
                  type="button"
                  class="decline-button"
                  @click="cancelPayment"
                >
                  <span class="button-texts"> {{ $translate("cancel") }}</span>
                </button>
              </b-col>
              <b-col cols="8">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="finalTransferSubmit()"
                >
                  <b-row class="fill-width">
                    <b-col cols="10"
                      ><span class="button-texts">
                        {{ $translate("nextStep") }}</span
                      ></b-col
                    >
                    <b-col cols="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </transition>
    <!--    Second Version ClubBaz-->
    <b-row v-if="getVersion === 'v2'">
      <b-col cols="7" class="d-none d-lg-block mt-10">
        <b-container>
          <img src="@/assets/images/mainPaymentImage.png" width="100%" />
        </b-container>
      </b-col>
      <b-col cols="12" lg="5">
        <b-row>
          <b-col
            cols="12"
            class="text-center black-text pt-2 font-size-medium-small"
          >
            <span>
              {{ $translate("shopName") }}:{{ $translate("clubBaz") }}
            </span>
          </b-col>
          <b-col
            cols="12"
            class="text-center light-grey-text pt-2 font-size-small pb-3 border-bottom-light-gray-2px-dashed"
          >
            {{ $translate("timeRemaining") }}:
            <strong class="red-text">
              <Timer
                ref="Transaction"
                :spanClass="'red-text'"
                :duration="300000"
                :timerKey="'Transaction'"
                @expired="expiredTransactionTimerAction"
              />
            </strong>
          </b-col>
        </b-row>

        <b-row class="font-size-small pt-2">
          <b-col cols="6"
            ><span class="light-grey-text"
              >{{ $translate("amountToPay") }}:</span
            ></b-col
          >
          <b-col cols="6" class="text-start"
            ><span class="green-text font-weight-bold"
              >{{ getShetabSelectedPayingAmount | commaSep | persianDigit }}
              {{ $translate("toman") }}</span
            ></b-col
          >
        </b-row>
        <b-container
          class="background-secondary border-radius-10px border-light-gray-1px mt-1 p-2 mb-2"
        >
          <b-row>
            <b-col
              cols="12"
              class="pb-1 black-text font-weight-bold font-size-small"
              >{{ $translate("cardNumber") }}:
            </b-col>
            <b-col cols="12" class="pb-1 black-text font-size-xs"
              >{{ $translate("enter16DigitCardNumber") }}
            </b-col>
          </b-row>
          <b-row class="direction-ltr m-0 pb-3">
            <div class="input-group p-0">
              <div class="input-group-prepend">
                <span class="input-group-text fill-height">
                  <img
                    :src="bankImageSource"
                    height="25"
                    width="25"
                    v-if="checkIfInputNotEmpty"
                  />
                </span>
              </div>
              <input
                v-for="(key, i) in creditCardInfo"
                :value="creditCardInfo[i].value"
                :key="key"
                readonly
                :class="{ secondVersionInputs: getVersion === 'v2' }"
                class="col-2 form-control mx-1"
              />
            </div>
          </b-row>
          <!--        <b-row style="padding-bottom:30px;" v-if="getNationalCodeNeeded">
                    <b-col cols="12" style="color: midnightblue; font-size: 0.8rem; padding-bottom: 3px;">
                      <span style="font-weight: bold">کد ملی</span>
                    </b-col>
                    <b-col cols="12" style="padding-bottom: 5px; color: midnightblue; font-size: 0.7rem">کد ملی  خود را وارد کنید</b-col>
                    <b-col cols="12">
                      <b-form-input class="form-control" type="password"  v-mask="'##########'" mask="false" v-model="nationalCode"></b-form-input>
                    </b-col>
                  </b-row>-->
          <b-row class="pb-4">
            <b-col cols="12" class="black-text font-size-small pb-1">
              <span class="font-weight-bold">{{
                $translate("cvv2Title")
              }}</span>
              <span>(cvv2)</span>
            </b-col>
            <b-col cols="12" class="pb-1 black-text font-size-xs"
              >{{ $translate("enterCvv2CodeInsertedIntoYourCard") }}
            </b-col>
            <b-col cols="12">
              <b-form-input
                class="form-control"
                type="text"
                pattern="\d*"
                inputmode="numeric"
                v-mask="'####'"
                mask="false"
                v-model="creditCardCVV2"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-col
            cols="12"
            class="black-text font-size-small pb-1 font-weight-bold"
            >{{ $translate("cardExpireTime") }}:
          </b-col>
          <b-col cols="12" class="pb-1 black-text font-size-xs"
            >{{ $translate("enterTheMonthAndYearOfCardExpiration") }}
          </b-col>
          <b-row class="black-text m-0 pb-3">
            <b-col cols="6" class="pr-0 pl-0point5">
              <b-form-input
                id="expireDateMonthInput"
                :placeholder="$translate('month')"
                v-mask="'##'"
                pattern="\d*"
                inputmode="numeric"
                mask="false"
                v-model="creditCardExpireDateMonth"
                :state="creditCardMonthExpireValidation"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="pl-0 pr-0point5">
              <b-form-input
                id="expireDateYearInput"
                class="col-6"
                :placeholder="$translate('year')"
                pattern="\d*"
                inputmode="numeric"
                v-mask="'##'"
                mask="false"
                v-model="creditCardExpireDateYear"
                :state="creditCardMonthExpireValidation"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="pb-3">
            <b-col
              cols="12"
              class="black-text font-size-small pb-1 font-weight-bold"
              >{{ $translate("cardSecondInternetPassword") }}:
            </b-col>
            <b-col cols="12" class="pb-1 black-text font-size-xs"
              >{{ $translate("enterTheSentPooyaPassword") }}
            </b-col>
            <b-row class="pl-0">
              <b-col cols="8" class="pl-0">
                <b-form-input
                  id="creditCardPasswordInput"
                  class="form-control"
                  type="password"
                  pattern="\d*"
                  inputmode="numeric"
                  v-mask="'########'"
                  mask="false"
                  v-model="creditCardPassword"
                  :class="{ secondVersionInputs: getVersion === 'v2' }"
                ></b-form-input>
              </b-col>
              <b-col cols="4" class="pl-0">
                <button class="password-request-button background-dark-green">
                  <span
                    v-if="!passwordRequestSend && !passwordRequestPending"
                    class="font-weight-bold"
                    @click="getCreditCardPass()"
                    >{{ $translate("receivePassword") }}</span
                  >
                  <div
                    v-if="passwordRequestPending && !passwordRequestSend"
                    class="spinner-border text-dark"
                    style="width: 0.9rem; height: 0.9rem"
                  ></div>
                  <span v-if="passwordRequestSend" class="text-white">
                    <Timer
                      ref="PasswordRequest"
                      :spanClass="'text-white'"
                      :duration="180000"
                      :timerKey="'PasswordRequest'"
                      @expired="expiredPasswordRequestAction"
                    />
                  </span>
                </button>
              </b-col>
            </b-row>
          </b-row>
          <b-col cols="12" class="pb-4">
            <label class="switch">
              <input
                type="checkbox"
                v-model="saveCardInfo"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
              />
              <span class="slider round"> </span>
            </label>
            <span class="font-size-xs font-weight-bold black-text pt-2">{{
              $translate("saveCArdNumberAndExpireDate")
            }}</span>
          </b-col>
          <b-row class="pb-4">
            <b-col cols="4">
              <button
                type="button"
                class="decline-button border-radius-5px"
                @click="cancelPayment"
              >
                <span class="button-texts">
                  {{ $translate("cancel") }}
                </span>
              </button>
            </b-col>
            <b-col cols="8">
              <button
                type="button"
                class="go-to-next-button background-light-green border-radius-5px"
                @click="finalTransferSubmit()"
              >
                <b-row class="fill-width">
                  <b-col cols="10"
                    ><span class="button-texts">
                      {{ $translate("nextStep") }}</span
                    ></b-col
                  >
                  <b-col cols="2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="currentColor"
                      class="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                      />
                    </svg>
                  </b-col>
                </b-row>
              </button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <!--    Second Version ClubBaz-->

    <!--    Modals-->
    <!--    Register in Shaparak Modal-->
    <ShaparakRegisterModal
      :visibility="shaparakRegisterModalShow"
      @close="shaparakRegisterModalShow = false"
    />
    <!--  when captcha validation success is received, we need to open the shaparak modal  -->
    <CaptchaValidationModal
      :visibility="captchaValidationModalShow"
      :captchaBase64="captchaImageBase64"
      :captchaAudioUrl="captchaAudioUrl"
      :multiImageCaptchaInfo="multiImageCaptchaInfo"
      @captchaIsValidSuccessEvent="shaparakRegisterModalShow = true"
      @close="captchaValidationModalShow = false"
    />
  </div>
</template>

<script>
import shetabStepper from "@/components/ShetabStepper";
import ShaparakRegisterModal from "@/components/Shaparak/Modals/ShaparakRegisterModal";
import CaptchaValidationModal from "@/components/Shetab/Modals/CaptchaValidationModal";
import Timer from "@/components/Timer";
import { paymentInformationMixin } from "@/mixins/ShetabMixins/PaymentInformationMixin";

export default {
  name: "paymentInformation",
  components: {
    Timer,
    CaptchaValidationModal,
    ShaparakRegisterModal,
    shetabStepper: shetabStepper,
  },
  mixins: [paymentInformationMixin],
};
</script>

<style scoped>
.password-request-button {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 5px;
  background: #079db1;
  color: white;
}

::placeholder {
  text-align: center;
}

.decline-button {
  width: 100%;
  height: 115%;
  border-radius: 10px;
  border: 1px solid var(--black);
  background-color: transparent;
}

.go-to-next-button {
  width: 100%;
  height: 115%;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

/*CustomSwitchBox*/
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 25px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 5px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #21f336;
}

input:focus + .slider {
  box-shadow: 0 0 1px #21f336;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/*Second Version Css*/
.secondVersionInputs {
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid var(--lighter-gray) !important;
}
</style>
